import { VueSlideToggle } from "vue-slide-toggle";
import { mapActions, mapGetters } from "vuex";
import { globalLoader } from "../../../../../helpers/variables";

export default {
    name: "ComsobaseMaterialInfo",
    props: {},
    emits: [],
    components: {
      VueSlideToggle,
    },
    setup() {},
    data() {
        return {
          open: false,
          openedItems: [],
        }
    },
    async created() {
      globalLoader(true)
      await Promise.all([
        this.getWebinarsById(this.$route.params.id)
      ])
      globalLoader(false)
    },
    mounted() {},
    watch: {},
    computed: {
      ...mapGetters({
        content: "cosmobase/webinar"
      })
    },
    methods: {
      ...mapActions({
        getWebinarsById: "cosmobase/GET_WEBINARS_BY_ID"
      }),
      isItemOpened(id) {
        return this.openedItems.includes(id);
      },
      toggleItem(id) {
        const index = this.openedItems.indexOf(id);
        if (index >= 0) {
          this.openedItems.splice(index, 1);
        } else {
          this.openedItems.push(id);
        }
      }
    }
}
